// The KBZPay SDK assumes it runs inside KBZPay: it talks to the app through a
// native bridge (Android viewLayerNative, iOS webkit.messageHandlers, or the KBZ
// simulator) and treats any other browser as iOS. Loaded anywhere else, every
// ma.* call - e.g. FlymyaSessionHook's getStorage on load - threw "Cannot read
// properties of undefined (reading 'messageHandlers')".
export const hasKbzBridge = () =>
  Boolean(
    window.viewLayerNative?.invoke ||
      window.webkit?.messageHandlers?.invoke ||
      window.simulatorWebkit?.messageHandlers?.invoke,
  );

/**
 * Loads the KBZPay SDK (window.ma) only where a bridge exists, leaving
 * window.ma undefined elsewhere - which every call site already checks for.
 * Safe to call from several modules: webpack runs the SDK once. The mini-app
 * login also loads it on demand (ensureKbzSdk in kbzAuthCode.js).
 */
export const loadKbzSdk = () => {
  if (hasKbzBridge()) {
    require("./js-sdk.min.js");
  }
};
